exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes dash-data-v-3b55cb48{to{stroke-dashoffset:-1000}}@keyframes dash-data-v-3b55cb48{to{stroke-dashoffset:-1000}}.path[data-v-3b55cb48]{-webkit-animation:dash-data-v-3b55cb48 30s linear infinite;animation:dash-data-v-3b55cb48 30s linear infinite;-webkit-animation-play-state:paused;animation-play-state:paused;stroke-dasharray:8}", ""]);

// exports
